export const NAV_LIST = [
  {
    title: '게임소개',
    link: '?menu=introduce',
    nav: 'GAME',
  },
  {
    title: 'with BTS',
    // link: "/community",
    link: '/devlog/withBTS',
    nav: 'withBTS',
  },
  {
    title: '랭킹',
    link: '/ranking',
    nav: 'RANKING',
  },
  {
    title: '공지사항',
    link: '/community/news',
    nav: 'COMMUNITY',
  },
  {
    title: '이벤트',
    // link: "/community",
    link: '/community/event',
    nav: 'EVENT',
    child: [],
  },
  {
    title: '쿠폰등록',
    // link: "/community",
    link: '/coupon',
    nav: 'COUPON',
    child: [],
  },
];
